



























import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";

import { Location } from "vue-router";
import EmployerGeneral from "./EmployerGeneral.vue";
import EmployerNavigation from "./EmployerNavigation.vue";
import EmployerBilling from "./EmployerBilling.vue";
import EmployerSettings from "./EmployerSettings.vue";
import EmployerDetails from "./EmployerDetails.vue";
import EmployerSftpSetting from "./EmployerSftpSetting.vue";
import AddEmployerUserForm from "@/shared/components/AddEmployerUserForm.vue";
import ManageEmployers from "@/shared/components/ManageEmployers.vue";
import EmployerTheme from "./EmployerTheme.vue";
import EmployerCustomization from "./EmployerCustomization.vue";
import DrivewealthOptions from "./DrivewealthOptions.vue";
import EmployerCardSettings from "./EmployerCardSettings.vue";
import { useEmployerStore } from "@/admin/store/employer";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import EmployerPrinCardSettings from "./EmployerPrinCardSettings.vue";
import EmployerMassTransitSettings from "@/admin/components/employer-management/EmployerMassTransitSettings.vue";

@Component({
  components: {
    EmployerMassTransitSettings,
    EmployerNavigation,
    EmployerDetails,
    EmployerGeneral,
    EmployerBilling,
    EmployerSettings,
    AddEmployerUserForm,
    ManageEmployers,
    EmployerSftpSetting,
    EmployerTheme,
    EmployerCustomization,
    DrivewealthOptions,
    EmployerCardSettings,
    EmployerPrinCardSettings
  }
})
export default class EmployerVue extends Vue {
  @Prop() employerId: number;
  @Prop() activeTab: string;
  @Prop() changePartner: string;
  @Prop() navigate: (args: { tabName: string }) => Location;
  @Prop() routeToEmployer: (args: { changePartner?: string }) => Location;

  employerStore = useEmployerStore();
  custodianSettingsStore = useCustodianSettingsStore();

  created () {
    this.fetchEmployer();
  }

  @Watch("employerId")
  fetchEmployer () {
    this.employerStore.loadEmployer(this.employerId);
    this.custodianSettingsStore.getEmployerCustodian(this.employerId);
  }
}
